import type {
  AnalyticsEvent,
  AnalyticsEventParamsOf,
} from "@v2/features/infra/analytics/events";

import * as React from "react";

import { useGetGlobalEventProperties } from "@v2/contexts/GlobalEventPropertiesContext";
import { analytics } from "@v2/features/infra/analytics/tracking";

export const useLogAnalytics = () => {
  const getGlobalEventProperties = useGetGlobalEventProperties();
  const logEvent = React.useCallback(
    function logEvent<EventName extends AnalyticsEvent["type"]>(
      eventName: EventName,
      eventProperties?: AnalyticsEventParamsOf<EventName>,
    ) {
      const globalProperties = getGlobalEventProperties();
      // NOTE (Ezra, 2026-02-11, REPL-23713): TS can't narrow the generic
      // union through the spread, so we need to cast.
      const merged = {
        ...eventProperties,
        ...globalProperties,
      } as AnalyticsEventParamsOf<EventName>;
      analytics.logEvent(eventName, merged);
    },
    [getGlobalEventProperties],
  );
  return logEvent;
};
